import * as Sentry from '@sentry/browser';
import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction';
import { persistStore } from 'redux-persist';
import createSagaMiddleware from 'redux-saga';
import createSentryMiddleware from 'redux-sentry-middleware';
import thunkMiddleware from 'redux-thunk';

import reducer, { RootState } from './reducers';
import rootSaga from './root-saga';

const sagaMiddleware = createSagaMiddleware();

const configureStore = (initialState = {}) => {
  const sentryMiddleware = createSentryMiddleware(Sentry, {
    getUserContext: (state: RootState) => state.me,
  });
  const middlewares = [thunkMiddleware, sentryMiddleware, sagaMiddleware];
  if (process.env.NODE_ENV === 'development') {
    const { createLogger } = require('redux-logger');
    const logger = createLogger({
      predicate: () => true,
    });
    middlewares.push(logger);
  }

  const composeEnhancers = composeWithDevTools({
    // options like actionSanitizer, stateSanitizer
  });

  const store = createStore(
    reducer,
    initialState,
    composeEnhancers(applyMiddleware(...middlewares))
  );

  if (process.env.NODE_ENV !== 'production') {
    if ((module as any).hot) {
      (module as any).hot.accept('./reducers', () => {
        store.replaceReducer(reducer);
      });
    }
  }

  return store;
};

export const store = configureStore();

sagaMiddleware.run(rootSaga, store.dispatch);

export const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
